'use strict';
import { contentfulValueToSlug } from '../integrations/contentful.delivery';
export const defaultServicePathPrefix = '/services';
export function normalizePathPrefix(prefix, fallback = defaultServicePathPrefix) {
    if (prefix == null || typeof prefix !== 'string')
        return fallback;
    const trimmed = prefix.trim();
    if (trimmed === '')
        return prefix === '' ? '' : fallback;
    if (trimmed === '/' || trimmed === '.' || trimmed === './')
        return '';
    const cleaned = trimmed.replace(/^\/+/, '').replace(/\/+$/, '');
    return cleaned ? `/${cleaned}` : '';
}
export function getServicePathPrefix(siteInfo, explicitPrefix) {
    if (typeof explicitPrefix === 'string') {
        return normalizePathPrefix(explicitPrefix, '');
    }
    return normalizePathPrefix(siteInfo?.servicesPathPrefix, defaultServicePathPrefix);
}
export function buildServiceUrl(service, prefix) {
    const resolvedPrefix = normalizePathPrefix(prefix);
    const slug = contentfulValueToSlug({ value: service?.name ?? '' });
    return slug ? `${resolvedPrefix}/${slug}` : resolvedPrefix;
}
export function resolveServices(props) {
    const candidates = props.services ?? props.siteInfo?.services ?? [];
    return candidates.filter((service) => Boolean(service));
}
export function findServiceBySlug(serviceSlug, siteInfo) {
    const slug = serviceSlug?.trim() || '';
    if (!slug)
        return undefined;
    const services = siteInfo?.services || [];
    return services.find((service) => {
        const candidateSlug = contentfulValueToSlug({ value: service?.name ?? '' });
        return candidateSlug === slug;
    });
}
